module.exports = __webpack_public_path__ + "static/media/elephant walking.da307b9d.gif";